export const darkPurple = "#2d0036";
export const accent = "#a259f7";